// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__PAb73","resendInfoText":"OnGoingPaymentBox_resendInfoText__2GB-E"};